export const MuiTypography = {
  defaultProps: {
    color: 'text.main',
    variant: 'baseRegular',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '100%',
    display: 'block',
  },
  variants: [
    {
      props: { variant: 'titleDashboard' },
      style: {
        fontSize: 12,
        lineHeight: '100%',
        fontWeight: 400,
        color: '#004744',
      },
    },
    {
      props: { variant: 'bigTitleSidebar' },
      style: {
        fontSize: 16,
        lineHeight: '1.3',
        fontWeight: 700,
        color: '#000',
        letterSpacing: '0.02em',
      },
    },
    {
      props: { variant: 'datetimeSidebar' },
      style: {
        fontSize: 14,
        lineHeight: '1.3',
        fontWeight: 400,
        color: '#5C5C5C',
      },
    },
  ],
}
